import { useEffect, useState } from 'react';

enum textLabels {
  problems = 'Medical problem',
  medications = 'Medication'
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useInputGeneratorLabels(fieldArrayName: string) {
  const [labelText, setLabelText] = useState('');

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const getLabelText = () =>
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      Object.values(textLabels)[
        Object.keys(textLabels).indexOf(fieldArrayName)
      ] || 'Default';
    const newLabelText = getLabelText();
    setLabelText(newLabelText);
  }, [fieldArrayName]);

  return labelText;
}
